/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthenticationService, private router: Router) { }

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) { // Check if user is authenticated
      this.authService.login(); // Redirect to Microsoft login page
      return false;
    } else {
      const userAuths = this.authService.userAuthorities;
      if (userAuths && userAuths.includes('user-view')) {
        return true;
      }
      return false;
    }
  }
}
